module.exports = __webpack_public_path__ + "img/update-details.6fe6f6a2.svg";